import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HeaderProfile from '../../../components/header_Profile/header_Profile.index';
import Investigation from './Investigation/investigation.index';
import styles from './investigation_diagnosis.module.css';
import { theme } from '../../../components/Medical_History_Forms/themeprovider';
import { Grid, ThemeProvider,Box, IconButton, Tooltip, } from '@mui/material';
import Diagnosis from './Diagnosis/diagnosis.index';
import { ReactComponent as PrinterIcon } from '../../../assets/SVG/printer (1).svg';
import InvestigationReportGen from '../../../components/Reports/Investigation/InvestigationReportGen';
import DiagnosisReportGen from '../../../components/Reports/Investigation/DiagnosisReportGen';
import { ButtonState, getButtonStates } from '../../../utils/permissionService';
import NoAccessPage from '../../noAccessPage';

interface PatientData {
  id: number;
  gender: 'MALE' | 'FEMALE';
  age: number;
  nameTitle: string;
  firstName: string;
  lastName: string;
  cycleNo: string;
  mrNo: string;
  updatedDatetime: Date;
  LastModified: string;
  visitID: string;
  genderId: string;
  visitedDoctorID: string;
  therapyId: string;
}


export default function InvestigationDiagno() {
  const { t: tGeneral } = useTranslation('general');
  const [selectedPatient, setselectedPatient] = useState<PatientData | null>(null);;
  const [activeTab, setActiveTab] = useState('Test');  
  const [openPreview, setOpenPreview] = useState(false);
  const [tableDataCount, setTableDataCount] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleDatafromHeader = (data: any) => {
    setselectedPatient(data);
  };

  const handleDataCountChange = (count: number) => {
    setTableDataCount(count);
  };

  // Import or define ButtonState type if not already imported
  // import { ButtonState } from '../../../utils/permissionService';
  const [buttonStates, setButtonStates] = useState<ButtonState>();
  useEffect(() => {

    const genderValue: 'male' | 'female' | undefined =
      selectedPatient?.gender === 'MALE'
        ? 'male'
        : selectedPatient?.gender === 'FEMALE'
          ? 'female'
          : undefined;
    const allStates = getButtonStates( 'Clinical', 'Investigations', activeTab === 'Test' ? 'Test' : 'Diagnosis', genderValue );
    setButtonStates(allStates);
    
    // Reset tableDataCount when switching tabs or changing patient to avoid stale data
    setTableDataCount(0);
   
  }, [activeTab, selectedPatient]);

  return (
    <ThemeProvider theme={theme}>
      <div>
        <div>
          <HeaderProfile onData={handleDatafromHeader} />
        </div>
        <Grid sx={{ my: 2, px: 3 }}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <div className={styles.tabs}>
              <button
                className={styles.tab}
                style={{
                  backgroundColor: activeTab === 'Test' ? 'white' : 'transparent',
                  color: activeTab === 'Test' ? '#f65e39' : 'black',
                  boxShadow: activeTab === 'Test' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '',
                }}
                onClick={() => setActiveTab('Test')}
              >
                {tGeneral('tab_Test')}
              </button>
              <button
                className={styles.tab}
                style={{
                  backgroundColor: activeTab === 'Diagnosis' ? 'white' : 'transparent',
                  color: activeTab === 'Diagnosis' ? '#f65e39' : 'black',
                  boxShadow: activeTab === 'Diagnosis' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : '',
                }}
                onClick={() => setActiveTab('Diagnosis')}
              >
                {tGeneral('tab_Diagnosis')}
              </button>
            </div>
            {buttonStates && buttonStates.canPrint && tableDataCount > 0 && (
              <Tooltip title="Print Report">
                <IconButton onClick={() => setOpenPreview(true)} sx={{ marginTop: '8px' }}>
                  <PrinterIcon />
                </IconButton>
              </Tooltip>
            )}

            {activeTab === 'Test' ? (
              <InvestigationReportGen
                open={openPreview}
                onClose={() => setOpenPreview(false)}
              />
            ) : (
              <DiagnosisReportGen
                open={openPreview}
                onClose={() => setOpenPreview(false)}
              />
            )}
          </Box>
          {buttonStates && (buttonStates.canView || buttonStates.canEdit || buttonStates.canAdd) ? (
            <Box mt={2}>
              {selectedPatient?.id && activeTab === 'Test' && <Investigation gender={selectedPatient.gender} onDataCountChange={handleDataCountChange} />}
              {selectedPatient?.id && activeTab === 'Diagnosis' && <Diagnosis gender={selectedPatient.gender} onDataCountChange={handleDataCountChange}/>}
            </Box>
          ) : (
            <NoAccessPage />
          )}

        </Grid>
      </div>
    </ThemeProvider>
  );
}